import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './index.css'

// Log for debugging
console.log('Initializing React application');

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)
